
import axios from "axios";
import { createContext , useContext , useEffect, useState } from "react";
import toast from "react-hot-toast";
import { UserContext } from "./UserContext.js";




export let CartContext = createContext();


export default function CartContextProvider(props){
   const [loading , setLoading] = useState(false)
   const [orderCount , setOrderCount] = useState(0)
   const [cart , setCart] = useState([]) ;
	const {userToken } = useContext(UserContext)
   const header = {
      token:`${process.env.REACT_APP_BEARER_TOKEN} ${userToken || localStorage.getItem("token")}`
   }

   async function addTest (test , company){
      await axios.post(`${process.env.REACT_APP_BASE_URL}/api/v1/cart` , {test_id:test ,company_id:company} ,  {headers:header} )
      .then(({data})=>{
         if(data.message === "success"){
            setCart(data.cart);
            toast.success(`${data.message }  Add Test in Cart [Total:${data?.cart?.cartItems.length}]`)
            getLoggedCart();
         }
      })
      .catch((error)=>{
         toast.error(error.response?.data.message)
      })
   }
   
   async function removeTest(test){
      await axios.delete(`${process.env.REACT_APP_BASE_URL}/api/v1/cart/${test}` ,  {headers:header} )
      .then(({data})=>{
         if(data.message === "success"){
            setCart(data.cart);
            toast.success( `${data.message }  Remove Test in Cart [Total:${data?.cart?.cartItems.length}]` ,{
               className:"toastAlert",
               duration:2000 , 
               position:'top-center'}
            );
            getLoggedCart();
         }
      })
      .catch((error)=>{
         toast.error(error.response?.data.message)
      })
   }
   
   async function clearCart(){
      await axios.delete(`${process.env.REACT_APP_BASE_URL}/api/v1/cart` ,  {headers:header} )
      .then(({data})=>{
         if(data.message === "success"){
            toast.success(`${data.message }  Clear Cart`) ;
            setCart([]);
         }
      })
      .catch((error)=>{
         toast.error(error.response?.data.message)
      })
   }

   
   async function getLoggedCart(){
      const header = {
         token:`${process.env.REACT_APP_BEARER_TOKEN} ${userToken || localStorage.getItem("token")}`
      }
      await axios.get(`${process.env.REACT_APP_BASE_URL}/api/v1/cart/userCart` ,  {headers:header} )
      .then(({data})=>{
         if(data.message === "success"){
            setCart(data.cart)
         }
      })
      .catch((error)=>{
         // console.log(error); 
      })
   }



      const getOrderCount = async()=>{
      const header = {
         token:`${process.env.REACT_APP_BEARER_TOKEN} ${userToken || localStorage.getItem("token")}`
      }
      await axios.get(`${process.env.REACT_APP_BASE_URL}/api/v1/order/getLoggedUserOrder`  ,  {headers:header})
      .then(({data})=>{
         setOrderCount(data.orderCount) ;
      })
      .catch((error)=>{
         // toast.error(error.response?.data.message)
      })
   }

   useEffect(() => {
      if(userToken){
         getLoggedCart();
         getOrderCount();
      }
   }, []);
   
   return (
      <>
         <CartContext.Provider 
         value={{

               orderCount ,
               setOrderCount ,
               getOrderCount ,

               loading , 
               setLoading  , 

               addTest , 
               removeTest , 
               getLoggedCart , 
               cart , 
               setCart , 
               clearCart
            }}>
            {props.children}
         </CartContext.Provider>
      </>
   )
}